import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';

export function getScales(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Scale`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getScaleId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Scale/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createScale(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('Scale', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateScaleId(id: string, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Scale/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export function deleteScaleId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.delete(`Scale/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

